import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Accordion,
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Grid,
  TextField,
} from "@material-ui/core";
import clsx from "clsx";

import SnackBar from "../../../components/SnackBar";
import { api_get, api_post } from "../../../utils/Api";
import Typography from "@material-ui/core/Typography";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ListGiftCode from "./ListGiftCodes";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  content: {
    padding: 0,
  },
  fontWeightMedium: {
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

const GiftCodeForm = (props) => {
  const { className, search, user, offer, quantity, allYear, edit, ...rest } =
    props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({
    code: "",
    offerId: offer,
    userId: user,
    quantity: quantity,
    allYear: allYear,
  });
  const [message, setAlertMessage] = useState("");
  const [severity, setAlertSeverity] = useState("success");
  const [userGiftCodes, setUserGiftCodes] = useState([]);
  const tableCell = ["id", "Code", "Action"];
  useEffect(() => {
    if (user) {
      getUserGiftCodes();
    }
  }, [user]);
  const getUserGiftCodes = () => {
    api_get(`generated-gifts/${user}`).then((result) => {
      setUserGiftCodes(result.payload);
    });
  };
  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const showErrorMessage = (errors) => {
    if (errors?.message) {
      setAlertMessage(errors.message);
    } else {
      Object.keys(errors).map(function (key, index) {
        if (index === 0) {
          setAlertMessage(errors[key][0]);
        }
      });
    }
    setAlertSeverity("error");
    setOpen(true);
  };
  const formValidation = (values) => {
    if (!values?.code) {
      return { success: false, message: "Gift Code is missing" };
    }

    if (!user) {
      return { success: false, message: "User is missing" };
    }
  };
  const handleSubmit = () => {
    const validation = formValidation(values);
    if (validation) {
      setAlertMessage(validation.message);
      setAlertSeverity("warning");
      setOpen(true);
    } else {
      api_post(`generated-gifts`, {
        code: values.code,
        userId: user,
      })
        .then((result) => {
          if (result.code !== 200) {
            showErrorMessage(result);
          } else {
            setAlertSeverity("success");
            setAlertMessage("User Gift Code successfully added");
            setOpen(true);
            getUserGiftCodes();
            setValues({
              ...values,
              quantity: "",
              code: "",
            });
          }
        })
        .catch((error) => {
          throw new Error(error);
        });
    }
  };

  return (
    <div>
      <Card {...rest} className={clsx(classes.root, className)}>
        <form autoComplete="off" noValidate>
          <ListGiftCode
            userGiftCodes={userGiftCodes}
            tableCell={tableCell}
            getData={getUserGiftCodes}
            user={user}
          />
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes?.heading}>
                Add New Gift Code
              </Typography>
            </AccordionSummary>
            <Divider />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label="Code"
                    name="code"
                    onChange={handleChange}
                    type="string"
                    required
                    value={values.code || ""}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardActions>
              <Button
                color="primary"
                variant="contained"
                onClick={(event) => handleSubmit(event)}
              >
                Add Code
              </Button>
            </CardActions>
          </Accordion>
        </form>
      </Card>
      <SnackBar
        open={open}
        message={message}
        severity={severity}
        handleClose={handleClose}
      />
    </div>
  );
};

export default GiftCodeForm;
